export default "__VITE_ASSET___94MPi3R__"